import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { chooseReasonsAction } from "features/application/form/redux/actions";

import ReasonsToJoinView from "features/application/reasons-to-join/view";

const mapDispatchToProps = (dispatch) => {
  return {
    chooseReasons: (reasons) => dispatch(chooseReasonsAction(reasons)),
  };
};

class ReasonsToJoin extends Component {
  constructor(props) {
    super(props);

    this.state = { error: null };

    this.reasons = [];

    this.toggleCheck = this.toggleCheck.bind(this);
    this.sendApiRequest = this.sendApiRequest.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { reasons } = this.props;

    if (nextProps.reasons && nextProps.reasons !== reasons) {
      for (let i = 0; i < nextProps.reasons.length; i++) {
        nextProps.reasons[i].is_selected &&
          this.reasons.push(nextProps.reasons[i].id);
      }
    }
  }

  toggleCheck(event) {
    this.setState({ error: null });

    if (event.target.className === "reasons-to-join__item") {
      if (event.target.dataset.reason && this.reasons.length < 3) {
        this.reasons.push(parseInt(event.target.dataset.reason));

        event.target.className = "reasons-to-join__item--checked";
      } else if (event.target.dataset.reason) {
        this.setState({ error: parseInt(event.target.dataset.reason) });
      }
    } else {
      event.target.className = "reasons-to-join__item";

      event.target.dataset.reason &&
        (this.reasons = this.reasons.filter(
          (value) => value !== parseInt(event.target.dataset.reason)
        ));
    }
  }

  sendApiRequest() {
    const { chooseReasons } = this.props;

    this.reasons.length && chooseReasons(this.reasons);
  }

  render() {
    const { userData, reasons } = this.props;

    return (
      <ReasonsToJoinView
        userData={userData}
        reasons={reasons}
        error={this.state.error}
        toggleCheck={this.toggleCheck}
        sendApiRequest={this.sendApiRequest}
      />
    );
  }
}

ReasonsToJoin.propTypes = {
  userData: PropTypes.object,
  reasons: PropTypes.array,
  chooseReasons: PropTypes.func,
};

export default connect(null, mapDispatchToProps)(ReasonsToJoin);
